<template>
    <div>
        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">Pattern</div>
            <TiptapEditor
                placeholder="Text to search for"
                :show-attributes="true"
                v-model="clone.find.pattern"
                :show-emoji="false"
                automation-mode
            />
            <small class="description">Enter the text pattern to find in the input</small>
        </div>

        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">Skip Count</div>
            <TiptapEditor
                placeholder="Number of instances to skip"
                :show-attributes="true"
                v-model="clone.find.skip"
                :show-emoji="false"
                automation-mode
            />
            <small class="description">Number of occurrences of the pattern to skip before returning</small>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../../../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";

const log = log2("StringFormatterFind");
export default {
    name: "StringFormatterFind",
    components: { TiptapEditor },
    props: ["value"],
    data() {
        const clone = _.cloneDeep(this.value) || {
            mode: "string.find",
            value: "",
            find: {
                skip: "0",
                pattern: "",
            }
        };
        return {
            clone,
        };
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
        value(newValue) {
            if (_.isEqual(newValue, this.clone)) return;
            this.clone = _.cloneDeep(newValue);
        },
    },
};
</script>

<style lang="scss" scoped>
.editor-row {
    width: 100%;

    &.customize-editor-minimize {
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    small.description {
        font-size: 10px;
        color: var(--color-text-weak-default);
    }

    .editor-row-title {
        font-weight: bold;
        font-size: 16px;
    }
}
</style> 